"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      boxShadow: theme.depth.d200,
      borderRadius: 4,
      overflow: 'hidden'
    },
    visibleContainer: {
      borderTop: '3px solid transparent',
      borderBottom: '3px solid transparent',
      backgroundColor: theme.palette.NEUTRAL010,
      display: 'flex',
      height: 46,
      alignItems: 'center'
    },
    contentsContainer: {
      backgroundColor: theme.palette.NEUTRAL010
    },
    error: {
      borderTop: "3px solid ".concat(theme.palette.RED400)
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      height: '100%',
      flex: '1 1 auto'
    },
    clickable: {
      cursor: 'pointer'
    },
    title: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(24),
      color: theme.palette.NEUTRAL600,
      flex: '1 1 auto',
      'white-space': 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.NEUTRAL300
    },
    required: {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.NEUTRAL600,
      fontWeight: 600
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.NEUTRAL200,
      flex: '0 0 auto',
      marginLeft: theme.spacing(1)
    },
    content: {
      width: '100%'
    },
    collapseMove: {
      cursor: 'pointer'
    },
    opened: {
      borderColor: 'transparent',
      backgroundColor: theme.palette.NEUTRAL600,
      '& $title, & $actions': {
        color: '#fff'
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;